module.exports = __webpack_public_path__ + "static/92-6c8ab5705021e34a1daf09312c8c6b01.png";